export default [
  {
    model_type: 'articles',
    url: '/destination',
    image: {
      preview: '/imgs/teacher-project/5-min.jpg',
    },
    title: '',
    announce: '',
    isBlank: false,
  },
  {
    model_type: 'specialproject',
    slug: 'https://местопамяти.рф/',
    image: {
      preview: '/imgs/teacher-project/1-min.jpg',
    },
    title: '',
    announce: '',
    isBlank: false,
  },
  {
    model_type: 'specialproject',
    slug: 'https://histrf.ru/read/articles/novosti-mobilnogo-prilozheniya-istoriya-rf',
    image: {
      preview: '/imgs/teacher-project/4-min.jpg',
    },
    title: '',
    announce: '',
    isBlank: false,
  },
  {
    model_type: 'specialproject',
    slug: 'https://гдеистория.рф/',
    image: {
      preview: '/imgs/teacher-project/2-min.jpg',
    },
    title: '',
    announce: '',
    isBlank: false,
  },
  {
    model_type: 'specialproject',
    slug: 'https://academia-moscow.ru/learning/uchebnyy-tsentr-ano-narpo/',
    image: {
      preview: '/imgs/teacher-project/23066ade-bfc4-49e6-8afd-d47e3b2f5ea7.jpg',
    },
    title: '',
    announce: '',
    isBlank: true,
  },
];
